export const template = (context, html) => html`
  <a dom-scope="ZQVVCESw" href="${context.href}" @click="${(e) => context.clickHandler(e)}">
    <slot></slot>
  </a>
`;
